export default __webpack_public_path__ + "static/amazon-9abe23eac1edad2abf7ff0da80f7eca9.png";